export default "__VITE_ASSET__mjTH4XqH__"